import Vue from 'vue'
import Vuex from 'vuex'
import { userId } from '../constant'
Vue.use(Vuex)



// 判断ios
const isIos =  function () {
  const u = navigator.userAgent
  return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS")
}



export default new Vuex.Store({
  state: {
    userId: localStorage.getItem('id') || userId,
    schoolId: localStorage.getItem('schoolId') || '',
    appId: localStorage.getItem('appId') || '',
    auditTabActive: 0,
    approvalBadge: {
      visitor: 0,
      leave: 0,
      pickup: 0,
      leaveoff: 0,
      personnel:0
    },
    subTitle: '' || sessionStorage.getItem('subTitle'),
    inviteSubData: {},
    // orderQuery: {}, // 下单成功参数
    vipData: [],
    puserId: '1096261353354625024',
    pschoolId: '1070770900580810752',

    // 苹果手机跳转地址
    wxSignUrl:''

  },
  mutations: {
    setpId(state, obj) {
      state.puserId = obj.id
      state.pschoolId = obj.schoolId
    },
    setUserId(state, userId) {
      state.userId = userId
      localStorage.setItem('id', userId)
    },
    setSchoolId(state, id) {
      state.schoolId = id
      // 正式环境换成这个
      localStorage.setItem('schoolId', id)
      //测试环境换成这个
      // localStorage.setItem('schoolId','1152695561751543808')
      
    },
    setAppId(state, id) {
      state.appId = id
      localStorage.setItem('appId', id)
    },
    auditTab(state, active) {
      state.auditTabActive = active
    },
    setTabBadge(state, badge) {
      state.approvalBadge[badge.type] = badge.value
    },
    setSubscribeTitle(state, title) {
      state.subTitle = title
      sessionStorage.setItem('subTitle', title)
    },
    setInviteSubData(state, data) {
      state.inviteSubData = data
    },
    setVipData(state, data) {
      state.vipData = data
      sessionStorage.setItem('vipData', JSON.stringify(data))
    },
    // setOrderQuery(state, data) {
    //   state.orderQuery = data
    // },
    setWechatSignUrl(state,wxSignUrl) {
      if (isIos() && state.wxSignUrl != '') {
        return 
      }
      state.wxSignUrl = wxSignUrl
    },
    

  },
  getters: {
    getWechatSignUrl: (state) => state.wxSignUrl
  },
  actions: {
    // changeOrderQuery({ commit }, data) {
    //   return new Promise((resolve, reject) => {
    //     commit('setOrderQuery', data)
    //     resolve()
    //   })
    // },
  },
  modules: {},
})
